import { render, staticRenderFns } from "./ClassInfo.vue?vue&type=template&id=18ec3d15&scoped=true&"
import script from "./ClassInfo.vue?vue&type=script&lang=js&"
export * from "./ClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClassInfo.vue?vue&type=style&index=0&id=18ec3d15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec3d15",
  null
  
)

export default component.exports